const borderRadius = {
  DEFAULT: "0.2rem", // 3px
}

module.exports = {
  borderRadius,
}

exports.default = borderRadius
